import { Link, matchPath, useLocation } from "react-router-dom";
import moment from "moment";

import orex from "@/assets/images/svg/orexlogo.svg";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { filter, isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";

import { motion } from "framer-motion";
import API_URL from "@/constant/api.config";
import axios from "axios";

const Footer = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [isAuthPage, setAuthPage] = useState(false);
  const [isProduct, setProductPage] = useState(false);
  const location = useLocation();

  const footerRef = useRef(null);
  const regRef = useRef(null);

  const fetchlandingProfile = async (id) => {

    await axios.get(API_URL + "/landing-profiles/" + id)
      .then((response) => {
        if (response.status === 200 && response.data.status) {
          if (response.data.data && response.data.data[0].trade_mode_type === "SUPPLIER") {
            setProductPage(true);
          }
        }
      })
      .catch((error) => {
        console.log("Error =========== ", error);
      });
  }

  useEffect(() => {
    const matchedRoutes = Object.values(publicRoutePaths).map((route) =>
      matchPath(route, location.pathname)
    );

    const matchFound = filter(matchedRoutes);

    if (!isEmpty(matchFound) && matchFound[0]?.pattern?.isAuthPage === true) {
      setAuthPage(true);
    } else {
      setAuthPage(false);
    }

    if (location.pathname == publicRoutePaths.MARKET_PLACE.path || location.pathname == publicRoutePaths.MARKET_DETAIL.path || location.pathname == publicRoutePaths.SEARCH_SUPPLIERS.path || location.pathname == publicRoutePaths.BECOME_SUPPLIER.path) {
      setProductPage(true);
    }

    if (!isEmpty(matchFound) && matchFound[0]?.pattern?.path === "/product-catalogue/:slug") {
      setProductPage(true);
    }

    if (!isEmpty(matchFound) && (matchFound[0]?.pattern?.path === "/landing/:id" || matchFound[0]?.pattern?.path === "/company-catalogue/:id")) {
      let pageid = matchFound[0].params.id;

      if (matchFound[0]?.pattern?.path === "/company-catalogue/:id") {
        setProductPage(true);
      } else {
        fetchlandingProfile(pageid);
      }

    }

  }, [location.pathname]);

  return (
    <>
      {!isAuthPage &&
        <>
          {location.pathname !== publicRoutePaths.CONTACT_US.path &&
            <section ref={regRef} className={`register-wrape strip ${isProduct ? 'marketing-register-now-wrape' : ''}`}> { /** marketing-register-now-wrape */}

              <div className="container">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="register-section">
                      <div className="container-fluid">
                        <div className="row">
                          <div className=" col-xl-7 col-lg-10 col-md-12 col-sm-12">
                            <div className="section-head dark">
                              <div className="head-text">
                                <motion.h2 className={`head animate-child`}
                                  initial="hidden"
                                  whileInView="visible"
                                  viewport={{ once: true, amount: 0.2 }}
                                  custom={0.2}
                                  variants={fadeUpVariant}
                                >
                                  Register Now
                                </motion.h2>
                              </div>

                              <motion.p className={`text animate-child`}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={0.2}
                                variants={fadeUpVariant}
                              >
                                Orex Trade is not just a network, but a global ecosystem that unites buyers, suppliers and logistics partners-helping you expand, connect and unlock new opportunities worldwide.
                              </motion.p>

                              <motion.p className={`text animate-child`}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={0.2}
                                variants={fadeUpVariant}
                              >
                                Have questions? Reach us at <Link to={`mailto:${process.env.REACT_APP_SUPPORT_MAIL}`} title={process.env.REACT_APP_SUPPORT_MAIL}>{process.env.REACT_APP_SUPPORT_MAIL}</Link>
                              </motion.p>
                            </div>

                            <div className="btn-wrape">
                              <motion.div
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={0.2}
                                variants={fadeUpVariant}>
                                <Link to={publicRoutePaths.REGISTRATION.path} title="Register Now" className={`btn red-btn auto-width`}
                                  target="_blank"
                                  href={publicRoutePaths.REGISTRATION.path}
                                >
                                  Register Now
                                </Link>
                              </motion.div>

                              <motion.div
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                custom={0.2}
                                variants={fadeUpVariant}
                              >
                                <a className={`btn outline auto-width`} title="Download Brochure" href={isProduct ? API_URL + `/brochure/download?t=supplier` : API_URL + `/brochure/download`}>
                                  <i className="sprite download"></i>
                                  Download Brochure
                                </a>
                              </motion.div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          }

          <footer ref={footerRef} className={`footer-effect`}>
            <div className="container">
              <div className="row">
                <div className="col-xxl-3"></div>
                <div className="col-xxl-9">
                  <div className="footer">
                    <div className="content-wrape">
                      <div className="footer-about">
                        <motion.div
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.5 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <Link to={publicRoutePaths.HOME.path} title="Orex Trade">
                            <img src={orex} alt="OrexTrade" className="f-logo" loading="lazy" width={256} height={87} />
                          </Link>
                        </motion.div>

                        <motion.div className={`social-media animate-child`}>
                          <a
                            href="https://www.facebook.com/people/OREX-TRADE-WORLD-INC/61571299940148/"
                            target="_blank"
                            className="fb"
                            title="Facebook"
                            rel="noreferrer"
                          >
                            <i className=""></i>
                          </a>
                          <a
                            href="https://www.linkedin.com/company/orextradeworld"
                            target="_blank"
                            className="linkedIn"
                            title="LinkedIn"
                            rel="noreferrer"
                          >
                            <i className=""></i>
                          </a>
                          <a
                            href="https://x.com/Orextradeworld"
                            target="_blank"
                            className="twitter"
                            title="X"
                            rel="noreferrer"
                          >
                            <i className=""></i>
                          </a>
                          <a
                            href="https://www.instagram.com/orextradeworld/"
                            target="_blank"
                            className="insta"
                            title="Instagram"
                            rel="noreferrer"
                          >
                            <i className=""></i>
                          </a>
                          <a
                            href="https://www.youtube.com/@OrexTradeWorldINC"
                            target="_blank"
                            className="youtube"
                            rel="noreferrer"
                          >
                            <i className=""></i>
                          </a>
                        </motion.div>
                      </div>

                      <div className="right-section">
                        <div className="inner-pad">
                          <div className={`section-pad `}>
                            <motion.h6
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.5 }}
                              custom={0.1}
                              variants={fadeUpVariant}>Quick Links</motion.h6>
                            <ul className="">
                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link to={publicRoutePaths.ABOUT_US.path} className={
                                  location.pathname ===
                                    publicRoutePaths.ABOUT_US.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } title="About Us">
                                  <i className=""></i> About Us
                                </Link>
                              </motion.li>
                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link className={
                                  location.pathname ===
                                    publicRoutePaths.OUR_SERVICES.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } to={publicRoutePaths.OUR_SERVICES.path} title="Our Services">
                                  <i className=""></i> Our Services
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link className={
                                  location.pathname ===
                                    publicRoutePaths.BECOME_SUPPLIER.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } to={publicRoutePaths.BECOME_SUPPLIER.path} title="Become a Supplier">
                                  <i className=""></i> Become a Supplier
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link className={
                                  location.pathname ===
                                    publicRoutePaths.JOIN_LOGISTIC.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Logistic Partner">
                                  <i className=""></i> Join as Logistic Partner
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link className={
                                  location.pathname ===
                                    publicRoutePaths.OUR_PRODUCTS.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } to={publicRoutePaths.OUR_PRODUCTS.path} title="Our Products">
                                  <i className=""></i> Our Products
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link className={
                                  location.pathname ===
                                    publicRoutePaths.CONTACT_US.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } to={publicRoutePaths.CONTACT_US.path} title="Contact Us">
                                  <i className=""></i> Contact Us
                                </Link>
                              </motion.li>

                            </ul>
                          </div>

                          <div className={`section-pad`}>

                            <motion.h6
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.5 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Benefits</motion.h6>
                            <ul className="">

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.GLOBAL_TRADE_NETWORK.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.GLOBAL_TRADE_NETWORK.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Global Trade Network"
                                >
                                  <i className=""></i> Global Trade Network
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.DIGITAL_PROMOTION.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.DIGITAL_PROMOTION.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Digital Promotion"
                                >
                                  <i className=""></i> Digital Promotion
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link to={publicRoutePaths.FINANCIAL_PROTECTION.path} className={
                                  location.pathname ===
                                    publicRoutePaths.FINANCIAL_PROTECTION.path
                                    ? "nav-link active"
                                    : "nav-link"
                                } title="Financial Protection">
                                  <i className=""></i> Financial Protection
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.BUSINESS_LEADS.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.BUSINESS_LEADS.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Quality Business Leads"
                                >
                                  <i className=""></i> Quality Business Leads
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.CUSTOMER_SUPPORT.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.CUSTOMER_SUPPORT.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Customer Support"
                                >
                                  <i className=""></i> Customer Support
                                </Link>
                              </motion.li>

                            </ul>
                          </div>

                          <div>

                            <motion.h6
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.5 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Other</motion.h6>
                            <ul className="">

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.EVENT_HIGHLIGHTS.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.EVENT_HIGHLIGHTS.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Events"
                                >
                                  <i className=""></i> Events
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.BLOG_LIST.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.BLOG_LIST.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Blogs"
                                >
                                  <i className=""></i> Blogs
                                </Link>
                              </motion.li>

                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.SUPPLIER_INQUIRY.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.SUPPLIER_INQUIRY.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Inquiry Supplier"
                                >
                                  <i className=""></i> Inquiry Supplier
                                </Link>
                              </motion.li>
                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}>
                                <Link
                                  to={publicRoutePaths.LOGISTIC_INQUIRY.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.LOGISTIC_INQUIRY.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Inquiry Logistic"
                                >
                                  <i className=""></i> Inquiry Logistic
                                </Link>
                              </motion.li>
                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.BUYER_SUPPLIER_TERMS.path}
                                  className={
                                    (location.pathname ===
                                      publicRoutePaths.BUYER_SUPPLIER_TERMS.path) || (location.pathname === publicRoutePaths.LOGISTIC_TERMS.path)
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Terms and Conditions"
                                >
                                  <i className=""></i> Terms and Conditions
                                </Link>
                              </motion.li>
                              <motion.li
                                className="animate-child"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                <Link
                                  to={publicRoutePaths.PRIVACY_POLICY.path}
                                  className={
                                    location.pathname ===
                                      publicRoutePaths.PRIVACY_POLICY.path
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  title="Privacy Policy"
                                >
                                  <i className=""></i> Privacy Policy
                                </Link>
                              </motion.li>

                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="footer-bottom">

                    <motion.div className={`copy-right animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.5 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Copyright © {moment().year()} All Rights Reserved.

                    </motion.div>

                    <motion.div className={`flags animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.5 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <h6 className="">Offices</h6>
                      <span className="flag usa"></span>
                      <span className="flag india"></span>
                      <span className="flag uae"></span>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </>
      }

      {
        isAuthPage &&
        <>
          <footer className="authfooter">
            <div className="container">

              <div className="footer-bottom">
                <div className="copy-right">
                  Copyright © {moment().year()} All Rights Reserved.
                  {/* Design & Developed By
                  <Link
                    className="footer-design"
                    to="https://infinglobal.com/"
                    target="_blank"
                    title="InfinGlobal"
                  >
                    {" "}
                    InfinGlobal
                  </Link> */}
                </div>

                <div className="flags">
                  <h6 className="">Offices</h6>
                  <span className="flag usa"></span>
                  <span className="flag india"></span>
                  <span className="flag uae"></span>
                </div>
              </div>
            </div>
          </footer>
        </>
      }



    </>
  );
}

export default React.memo(Footer);
